import { render, staticRenderFns } from "./ManageReports.vue?vue&type=template&id=2b0970c6&scoped=true&"
import script from "./ManageReports.vue?vue&type=script&lang=js&"
export * from "./ManageReports.vue?vue&type=script&lang=js&"
import style0 from "./ManageReports.vue?vue&type=style&index=0&id=2b0970c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0970c6",
  null
  
)

export default component.exports